import { createContext } from 'react';

const LabelContext = createContext();

export default LabelContext;